import { useStaticQuery, graphql } from "gatsby"
import { GatsbyCreatePageContext } from "types/gatsby-create-page-context";

export type AllSitePageData = {
    id: string;
    path: string;
    component: string;
    pageContext: GatsbyCreatePageContext
};

export const useAllSitePageData = (): AllSitePageData[] => {
    const { allSitePage } = useStaticQuery<Queries.AllSitePagesQuery>(
        graphql`
            query AllSitePages {
                allSitePage {
                    edges {
                        node {
                            id
                            path
                            component
                            pageContext
                        }
                    }
                }
            }
        `
    );

    return allSitePage.edges.map(({node: page}) => {
        return {
            id: page.id,
            path: page.path,
            component: page.component,
            pageContext: page.pageContext as GatsbyCreatePageContext
        }
    });
};